export interface ScreenWorldCamera {
  getWorldPoint(screenX: number, screenY: number): { x: number; y: number };
}

export interface TilePoint {
  column: number;
  row: number;
  x: number;
  y: number;
}

export function worldPointToTile(
  point: { x: number; y: number },
  tileSize: number,
): { column: number; row: number } {
  if (!Number.isFinite(tileSize) || tileSize <= 0)
    throw new RangeError("Tile size must be a positive number");
  return {
    column: Math.floor(point.x / tileSize),
    row: Math.floor(point.y / tileSize),
  };
}

export function screenPointToTile(
  camera: ScreenWorldCamera,
  screenX: number,
  screenY: number,
  tileSize: number,
): TilePoint {
  const world = camera.getWorldPoint(screenX, screenY);
  const { column, row } = worldPointToTile(world, tileSize);
  return {
    column,
    row,
    x: column * tileSize + tileSize / 2,
    y: row * tileSize + tileSize / 2,
  };
}

export function isTileInsideMap(
  tile: { column: number; row: number },
  columns: number,
  rows: number,
): boolean {
  return (
    tile.column >= 0 &&
    tile.column < columns &&
    tile.row >= 0 &&
    tile.row < rows
  );
}
